import { render, staticRenderFns } from "./BkashPrizeImage.vue?vue&type=template&id=3b7355d4&scoped=true&"
import script from "./BkashPrizeImage.vue?vue&type=script&lang=js&"
export * from "./BkashPrizeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7355d4",
  null
  
)

export default component.exports